/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { SendPasswordResetOptions, SendPasswordResetResponses } from '../../models/SendPasswordReset'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Request a password reset by email address.
 * @summary Send Password Reset
 * {@link /auth/send-password-reset}
 */
export function sendPasswordReset<ThrowOnError extends boolean = true>(options: Options<SendPasswordResetOptions, ThrowOnError>): Promise<UnwrappedResult<SendPasswordResetResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/auth/send-password-reset', ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<SendPasswordResetResponses, ThrowOnError>>
}
